import { skipToken } from '@reduxjs/toolkit/dist/query';

import { useFetchRubricQuery } from 'app/apis/reviews';
import { Submission } from 'app/types/reviews';

/**
 * Hook to fetch the appropriate rubric for a submission.
 * Returns both the display rubric (English source for cross-lang reviews) and the submission's rubric.
 * For cross-language reviews, fetches the English source rubric using translation_source_id.
 * For regular reviews, uses the submission's rubric for display.
 */
export const useProjectRubric = (submission: Submission | undefined) => {
  const isCrossLangReview = !!submission?.crossLangReview;

  // Always fetch submission rubric first
  const { data: submissionRubric } = useFetchRubricQuery(submission?.rubricId ? submission.rubricId : skipToken);

  // For cross-lang reviews, fetch the English source rubric using translation_source_id.
  // Falls back to submission's rubric if translation_source_id is null.
  const { data: englishSourceRubric } = useFetchRubricQuery(
    isCrossLangReview && submissionRubric?.translationSourceId ? submissionRubric.translationSourceId : skipToken
  );

  // English source rubric for cross-lang, otherwise submission's rubric
  const rubric = isCrossLangReview && englishSourceRubric ? englishSourceRubric : submissionRubric;

  return { rubric, submissionRubric };
};
